<template>
    <div class="index-box">
        <div class="index-title">h5页面创作</div>

        <input type="text"  style="height:40px;width:100%;font-size:18px;border:none;text-indent: 10px;background:#eee;" v-model="title" placeholder="这是标题"/>


        <div class="mt10">
           选择编辑模式：

             <span @click="view_type=0" class="pad510 border-gray"  :class="view_type==0?'bg_blue':''">视图</span>
             <span @click="view_type=1" class="pad510 border-gray ml10" :class="view_type==1?'bg_blue':''">源代码</span>


        </div>
        <template v-if="view_type==0">

          <div style="border: 1px solid #ccc;margin-top: 15px;">
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"

            />
            <Editor
                style="height: 500px; overflow-y: hidden;"
                v-model="html"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
            />
          </div>
        </template>

      <div v-if="view_type==1" class="mt15">
        <textarea v-model="html2" style="width:98%;height:500px;border:1px solid #ccc;background:#f1f1f1;"></textarea>

      </div>


      <div style="padding:20px 0;">

        <div class="mb-10">
          选择专属域名：
          <el-select v-model="exc_domain_id" clearable placeholder="请选择" :loading="isLoading" @visible-change="getDomainList">
            <el-option v-for="item in options" :key="item.id" :label="item.domain" :value="item.id"></el-option>
          </el-select>
            <router-link to="/tabs/buyDomain" style="font-size: 12px;background:#f0f9f3;color:#037d2b;padding:6px 10px;margin-left: 20px;font-weight: bold;"> &nbsp;
              <em class="iconfont icon-dwzRectangleCopy23"></em> 提示：专人专用-域名首页直接展示，点击购买
           </router-link>
          <div>

            <div  style="background:#f8f8f8;line-height: 150%;font-size:14px;padding:10px; margin-top: 10px;">
              <div style="font-weight: bold;">专属域名的优势：</div>
              1. 不被共享域名污染，共享域名其中一个用户的链接被微信拉红，所有链接都会被红，专属域名不会出现被他人链接污染的情况，专人专用 <br>
              2. 专属链接可自由定义页面，去除版权信息  <br>
              3. 享受定制样式，可完全diy页面  <br>


            </div>

              <div class="mb-10 mt6" style="margin-top: 15px;">
                  是否手机版:

                  <span @click="diy_free=0" class="pad510 border-gray"  :class="diy_free==0?'bg_blue':''">手机</span>
                  <span @click="diy_free=1" class="pad510 border-gray ml10" :class="diy_free==1?'bg_blue':''">电脑</span>


              </div>

            <div class="mb-10 mt6" style="margin-top: 15px;">
              样式或js代码:  <span style="color:blue;cursor: default" @click="show_body_code=!show_body_code">+展开</span>
              <textarea v-if="show_body_code" v-model="body_code" style="width:100%;height:500px;border:1px solid #ccc;background:#f8f8f8;margin-top:10px;"></textarea>

            </div>

          </div>


        </div>
      </div>
        <div style="width: 250px;margin: 60px 37%">
          <el-button class="btn-box"  type="primary" @click="submitForm">立刻创建</el-button>
        </div>

    </div>

</template>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {client, getFileNameUUID} from "@/utils/oss";
import { IEditorConfig, createEditor, createToolbar } from '@wangeditor/editor'


export default {
        components: { Editor, Toolbar },
        name: "WebPage",
        data() {
           var that=this;
          return {
            view_type:0,
            dataObj: {}, //存签名信息
            editor: null,
            html: '',
              html2:'', //源码模式html
            title:'',
            diy_free:0,
            show_body_code:0,
            body_code:'',
            uid:0,
            userInfo:{uid:0},
            toolbarConfig: { },
            exc_domain_id:'',
            isLoading:false,
            options:[],
            editorConfig: {
              placeholder: '请输入内容...',
              // MENU_CONF: {},
              MENU_CONF:{
                uploadImage:{
                  async customUpload(file,insertFn) {
                    var $this=this;

                    async function multipartUpload() {
                      let temporary = file.name.lastIndexOf(".");
                      let fileNameLength = file.name.length;
                      let fileFormat = file.name.substring(
                          temporary + 1,
                          fileNameLength
                      );
                      console.log(file)
                      that.$common.Upload({file:file},function(img){
                        insertFn(img, img, img)
                      });

                    }
                    multipartUpload();
                  },
                },
                uploadVideo:{
                  server: 'https://api.ttdwz.cc/pc/common/uploadVideo2?uid='+this.$storeLocal.get('userInfo').uid,
                  allowedFileTypes: ['video/mp4'],
                  maxFileSize: 30 * 1024 * 1024, // 5M
                  meta: {

                  },
                  // 上传之前触发
                  onBeforeUpload(file) {
                    // file 选中的文件，格式如 { key: file }
                    return file

                    // 可以 return
                    // 1. return file 或者 new 一个 file ，接下来将上传
                    // 2. return false ，不上传这个 file
                  },
                  // 上传进度的回调函数
                  onProgress(progress) {
                    // progress 是 0-100 的数字
                    console.log('progress', progress)
                  },
                  // 单个文件上传成功之后
                  onSuccess(file, res) {
                    console.log(`${file.name} 111上传成功`, res)
                  },
                  // 单个文件上传失败
                  onFailed(file, res) {
                    console.log(`${file.name} 222上传失败`, res)
                  },
                  // 上传错误，或者触发 timeout 超时
                  onError(file, err, res) {
                    console.log(`${file.name} 111上传出错`, err, res)
                  },
                }
              },
              // MENU_CONF['uploadImage']={},
            },

            mode: 'default',
          }

        },
        mounted() {

            setTimeout(() => {
              //this.html = ''
            }, 1500)




          },
        beforeDestroy() {
          const editor = this.editor
          if (editor == null) return
          editor.destroy() // 组件销毁时，及时销毁编辑器
        },
        methods: {

          onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错

          },

          async getDomainList(val) {
              if (!val) return;
              if (this.isLoad) return;
              const {ret,data} = await this.$api.exclusive.getUserList();
              if (ret === 1000){
                this.isLoad = true;
                this.isLoading = false;
                this.options = data.list;
              }
            },

          async submitForm() {
            console.log(this.html)
              var code=this.html;
            if(this.view_type==1){
                code=this.html2;
            }

            const postData = {
              title:this.title,
              texthtml: code,
              ext_domain_id:this.exc_domain_id,
              diy_free:this.diy_free,
              body_code:this.body_code
            };
            const {ret,data} = await this.$api.webpage.create(postData);
            if (ret === 1000){
              this.$message.success("转换成功");
              await this.$router.push('/tabs/webPageList');
              //await this.$router.push('/conversion/' + data.id);
              // this.shortId = data.id;
              // this.shortUrl = data.huomaname;
              // this.bindQRCode();
            }
          },
          handleDevChange(value) {
            this.diy_free = value;
          },
        },

    }
</script>

<style scoped>
    .index-box{
        width: 940px;
        height: auto;
        margin-left: 80px;
        padding: 30px 120px 30px 40px;
    }
    .index-box .index-title{
        width: 100%;
        height: 28px;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .index-box .btn-box{
        width: 100%;
    }

    .result-box .top-ico i{
        display: inline-block;
        font-size: 40px;
        margin-right: 10px;
        vertical-align: top;
    }
    a{
      text-decoration: none;
      cursor: pointer;
      color: #2e6ab1;
    }

</style>
